var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.5C0 14.8269 14.3269 0.5 32 0.5C49.6731 0.5 64 14.8269 64 32.5C64 50.1731 49.6731 64.5 32 64.5C14.3269 64.5 0 50.1731 0 32.5Z",
    fill: "url(#paint0_linear_4855_578)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 27.25C22.25 35.5343 28.9657 42.25 37.25 42.25H39.5C40.7426 42.25 41.75 41.2426 41.75 40V38.6284C41.75 38.1121 41.3987 37.6622 40.8979 37.537L36.4747 36.4312C36.0355 36.3214 35.5734 36.4855 35.3018 36.8476L34.3316 38.1412C34.05 38.5166 33.563 38.6827 33.1223 38.5212C29.8154 37.3098 27.1902 34.6846 25.9788 31.3777C25.8173 30.937 25.9834 30.45 26.3588 30.1684L27.6524 29.1982C28.0145 28.9266 28.1786 28.4645 28.0688 28.0253L26.963 23.6021C26.8378 23.1013 26.3879 22.75 25.8716 22.75H24.5C23.2574 22.75 22.25 23.7574 22.25 25V27.25Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4855_578",
    x1: 64,
    y1: 32.5,
    x2: 1.75936,
    y2: 22.0356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6007E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#471D7C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.3584d5f2f9a90852220d01bb7a7bfe19.svg";
export { ForwardRef as ReactComponent };